module.exports = "https://cdn.hellotech.com/client-assets/electrical-panel-main_da606084807238c162a3aeb637f38588.png";